<div class="modal-header">
    <h4 class="modal-title">{{data?.dialogHeading}}</h4>
    <h4 class="modal-sub-title" style="line-height: 2.4rem;" [innerHTML]="data?.dialogSubHeading"></h4>
</div>

<div class="modal-body1">
    <ng-container *ngIf="data?.bodyNotifySupportEmail">
        <p class="text-center">
            <strong style="color: #000;" [innerHTML]="data?.bodyNotifySupportEmail"></strong>
        </p>
    </ng-container>

    <ng-container *ngIf="data?.bodyNormalContent">
        <h4 class="minimum-balance-text" style="line-height: 2.4rem;">
            {{data.bodyNormalContent}}
        </h4>
    </ng-container>

    <ng-container *ngIf="data?.bodyTitle">
        <h4 class="body-title mt-4">
            {{data.bodyTitle}}
        </h4>
    </ng-container>

    <div class="modal-add-money row">
        <form name="form" (keydown.enter)="$event.preventDefault()"
            (ngSubmit)="topupAmountForm.form.valid && onAddMoneyClick(topupAmount)" #topupAmountForm="ngForm">
            <span class="enter-amount-txt">{{data.bodyEnterAmount || "Enter Amount:"}}</span>
            <input class="topup-amount-input" [(ngModel)]="topupAmount" name="topupAmount" type="number"
                onKeyPress="if(this.value.length==10) return false;" placeholder="">

            <span>
                <button class="add-fund-btn float-md-right" type="submit" mat-flat-button
                    [disabled]="!isFormValid(topupAmountForm.valid)">
                    {{ data.payButtonText || 'Add Fund to Wallet' }}
                </button>
            </span>
        </form>
    </div>
    <span class="finzy-red" *ngIf="topupAmount<=0">
        {{ data.amountWarningText || "Please enter the valid amount"}}
    </span>
    <ng-container *ngIf="!data.hideBankDetails">
        <div class="row">
            <p class="section-break"> <span class="mid-text"> OR </span> </p>
        </div>
        <div class="row">
            <h4 class="body-title1" [innerHTML]="data.tableHeading"></h4>
        </div>

        <div class="row">
            <table class="table table-responsive">
                <tbody>
                    <tr>
                        <td class="table-left">Account Name</td>
                        <td class="table-right">{{data.bankDetails['Account Name']}}</td>
                    </tr>
                    <tr>
                        <td class="table-left">Bank</td>
                        <td class="table-right">{{data.bankDetails['Bank']}}</td>
                    </tr>
                    <tr>
                        <td class="table-left">Virtual Account Number</td>
                        <td class="table-right">
                            <div class="col-md-6 p-0 m-0">
                                {{data.bankDetails['Virtual Account Number']}}
                            </div>
                            <div class="col-md-6 p-0 m-0">
                                <a class="virtial-acc-sub-text" role="button"
                                    (click)="onClickVirtualAccountDiscriptionOpen()">How does this work?</a>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="isVirtualAccountDiscriptionOpen" id="virtualAccountDiscription">
                        <td colspan="2" class="virtial-acc-discription">
                            <h5 role="button" class="virtial-acc-discription-title"
                                (click)="onClickVirtualAccountDiscriptionClose()">
                                How virtual account work?</h5>
                            <div class="virtial-acc-discription-detail">
                                You can transfer money to your finzy wallet via the unique Virtual Account Number
                                assigned
                                to
                                your finzy investment account. This works like any other beneficiary account.
                            </div>
                            <div class="virtial-acc-discription-detail">
                                To add money to your finzy wallet -
                            </div>
                            <ol class="col-12 virtial-acc-discription-detail">
                                <li> Add the Virtual Account Number assigned to you as a beneficiary in your bank
                                    account
                                </li>
                                <ul>
                                    <li> Payee Account Name is "Bridge Fintech Solutions Pvt Ltd"</li>

                                    <li> Payee Account Number is your unique Virtual Account ID displayed on the
                                        dashboard
                                    </li>
                                </ul>
                                <li> Make a transfer to the Virtual Account (using NEFT/IMPS/RTGS)</li>
                                <li> Once the funds are credited to the finzy Escrow account, we will automatically
                                    update
                                    your wallet to
                                    reflect the same and you can start investing!
                                </li>
                            </ol>
                            <div class="virtial-acc-discription-detail add-space">
                                Note: Some banks might not allow adding Virtual Account IDs as a new beneficiary on
                                their
                                mobile app. In such a case, you might have to login using the web version of the bank to
                                add
                                the beneficiary For more information on Virtual Account, please check our FAQs.
                                <button class="back-btn float-right"
                                    (click)="onClickVirtualAccountDiscriptionClose()">Close</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-left">Account type</td>
                        <td class="table-right">{{data.bankDetails['Account type']}}</td>
                    </tr>
                    <tr>
                        <td class="table-left ifsc-code">{{'IFSC code'}}</td>
                        <td class="table-right ifsc-number">{{data.bankDetails['IFSC code']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>